import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Typography } from '@mui/material';
import { ModalSize } from 'app/shared/componentsRestyled/coreDesignSystem/Modals';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { openDialogAction } from 'store/global/actions';

import AusFindings from '../MainHeaderContent/AusFindings';
import ActionButton from '../RedesignedLoanInfoHeader/ActionButton';

import {
  findingButtonCustomStyles,
  findingReportTextStyles,
  FindingReportWrapper,
} from './AusComparison.styles';

const FindingReport = ({ loanId, typeOfAus, lastDocumentDate }) => {
  const dispatch = useDispatch();

  const formattedDate = dayjs(lastDocumentDate).format(COMMON_DATETIME_FORMAT);

  const onClick = useCallback(
    e => {
      e.preventDefault();

      dispatch(
        openDialogAction({
          header: 'View Document',
          size: ModalSize.XL,
          hasScrollY: false,
          body: () => <AusFindings isInModal loanId={loanId} typeOfAus={typeOfAus} />,
        }),
      );
    },
    [dispatch, loanId, typeOfAus],
  );

  return (
    <FindingReportWrapper>
      <ActionButton customStyles={findingButtonCustomStyles} onClick={onClick}>
        View Findings
      </ActionButton>
      <Typography sx={findingReportTextStyles} variant="regular14">
        {formattedDate}
      </Typography>
    </FindingReportWrapper>
  );
};

FindingReport.propTypes = {
  typeOfAus: PropTypes.string.isRequired,
  loanId: PropTypes.string.isRequired,
  lastDocumentDate: PropTypes.string.isRequired,
};

export default FindingReport;
